import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type PXGatewayDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const PXGatewayDeviceRegistrationEndpointSpecification: PXGatewayDeviceRegistrationEndpointSpecification = {
    url: '/api/device/registration',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'PxGatewayDeviceRegistrationRequestParams',
    requestBodySchemaName: 'PxGatewayDeviceRegistrationRequestBody',
    okResponseSchemaName: 'PxGatewayDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokePXGatewayDeviceRegistration = Helpers.makeApiRequestFn<
    Types.PXGatewayDeviceRegistrationRequestParams,
    Types.PXGatewayDeviceRegistrationRequestBody,
    Types.PXGatewayDeviceRegistrationOkResponse
>(PXGatewayDeviceRegistrationEndpointSpecification);
